import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App.tsx';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);


/**
 * 【public/index.html との繋がりについて】
 * document.getElementById('root') は、public/index.html 内にある <div id="root"> を参照しています。
 * 1. インポート不要の理由: ブラウザがHTMLを読み込んだ後、JSがグローバルな「document」を通じて要素を探す標準的な仕組みだからです。
 * 2. 結びつきの仕組み: ビルドツールがこのJSファイルを index.html の末尾に自動で埋め込むため、実行時には同じページ内の要素として認識されます。
 *
 * index.htmlにid=rootと宣言しておくとJS側からその名前を指定して呼び出すことができる。（htmlでimportしていない理由は↑に記載)
 * →index.jsに飛んでAPP.tsxをAppと名前をつけてApp.tsxに飛ぶ。
 * →App.tsxでrouter/RouterをAppRouterと名前をつけてRouter.tsxに飛ぶ。
 * →Router.tsxでpagesをimportがあり、画面遷移先がそれぞれあり該当のファイルに飛ぶ。
 */
